import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nNumber } from "@lookiero/i18n-react";
import { Currency } from "@lookiero/sty-psp-locale";
import { Text } from "@lookiero/sty-psp-ui";
import { DOMAIN } from "../../../../i18n/i18n";
import { style as priceStyle } from "./Price.style";

interface PriceProps {
  readonly amount: number;
  readonly currency: Currency;
  readonly discountedPrice?: {
    readonly amount: number;
    readonly percentage: number;
  };
  readonly withPercentage?: boolean;
}
const Price: FC<PriceProps> = ({ amount, currency, discountedPrice, withPercentage = false }) => {
  const isDiscounted = discountedPrice && discountedPrice.percentage > 0;
  const productPrice = useI18nNumber({
    domain: DOMAIN,
    value: amount / 100,
    style: "currency",
    currency,
  });
  const productDiscountedPrice = useI18nNumber({
    domain: DOMAIN,
    value: (discountedPrice?.amount || 0) / 100,
    style: "currency",
    currency,
  });

  const priceValue = isDiscounted ? productDiscountedPrice : productPrice;

  const style = useMemo(() => priceStyle(), []);

  return (
    <View style={style.price} testID="price">
      {isDiscounted && (
        <Text level={1} style={style.discountedPriceText} testID="discounted-price-text" variant="detail">
          {productPrice}
        </Text>
      )}
      <View style={style.discountedPriceInfo}>
        <Text level={1} testID="price-text" variant="detail">
          {priceValue}
        </Text>
        {isDiscounted && withPercentage ? (
          <Text level={1} style={style.discountedPercentage} testID="discounted-percentage-text" variant="detail">
            {`-${discountedPrice.percentage}%`}
          </Text>
        ) : null}
      </View>
    </View>
  );
};

export { Price };
